module.exports = __webpack_public_path__ + "img/a6ee31b.png";